import { enLang, ruLang } from './ls-load-save';

export const localizationObj = {
  [ruLang]: {
    signIn: 'Вход',
    signUp: 'Регистрация',
    signOut: 'Выход',
    language: 'Язык',
    profile: 'Профиль',
    meetOurTeam: 'Наша команда',
    login: 'Логин',
    password: 'Пароль',
    name: 'Имя',
    repeatPassword: 'Повторите пароль',
    editUser: 'Редактировать пользователя',
    changePassword: 'Сменить пароль',
    deleteUser: 'Удалить пользователя',
    oldPassword: 'Старый пароль',
    newPassword: 'Новый пароль',
    enterYourPassword: 'Введите свой пароль',
    enterYourLogin: 'Введите свой логин',
    enterYourName: 'Введите свое имя',
    emptyField: 'Пустое поле',
    onlyNumbersLetters: 'Только цифры и латинские буквы',
    lessThanFour: ' не может быть короче 4 символов',
    passwordsMatch: 'Пароли не совпадают',
    createBoard: 'Создать новую доску',
    createColumn: 'Добавить колонку',
    createTask: 'Добавить задачу',
    yourBoards: 'Ваши доски',
    board: 'Доска',
    boards: 'Доски',
    boardsHeader: 'На главную',
    openBoard: 'Открыть доску',
    back: 'Назад',
    submit: 'Подтвердить',
    cancel: 'Отмена',
    doYouWantToDelete: 'Вы хотите удалить',
    areYouSure: 'Вы уверены?',
    error: 'Ошибка!',
    success: 'Успех!',
    updateSuccessful: 'обновлен успешно!',
    user: 'Пользователь',
    wrongPassword: 'Неверный пароль',
    afterDeleteRedirect:
      'После удаления пользователя вы будете перенаправлены на главную страницу!',
    update: 'Обновить',
    loading: 'Загрузка...',
    addATitle: 'Добавить заголовок',
    addADescription: 'Добавить описание',
    author: 'Пользователь',
    yourTask: 'Задача',
    taskDescription: 'Описание',
    shatau: 'Евгений Шатов',
    kochieva: 'Виктория Кочиева',
    karakulka: 'Дмитрий Каракулько',
    doYouWantToChangeUser: 'Выберите нового пользователя',
    welcome: 'Добро пожаловать',
    app: 'Ваша система управлениями проектами',
    aboutProject:
      'Приложение для управления проектами — это приложение, которое назначает задачи отдельным участникам проекта или группы. Это визуальный инструмент, который позволяет вашей команде управлять любым типом проекта, рабочим процессом или отслеживанием задач. Добавьте файлы, контрольные списки или даже автоматизацию: настройте все так, чтобы ваша команда работала лучше всего. Просто зарегистрируйтесь, создайте доску, и вперед!',
    course:
      'RS School — это бесплатная образовательная программа, проводимая сообществом разработчиков The Rolling Scopes с 2013 года. Учиться в RS School может каждый, независимо от возраста, профессиональной занятости и места жительства. Наставники и тренеры нашей школы — фронтенд- и javascript-разработчики из разных компаний и стран. В RS School работает принцип «Плати вперед». Мы бесплатно делимся с учащимися своими знаниями в настоящее время, надеясь, что в будущем они вернутся к нам в качестве наставников и точно так же передадут свои знания последующему поколению студентов.',
    courseAbout: 'О курсе',
  },
  [enLang]: {
    signIn: 'Sign In',
    signUp: 'Sign Up',
    signOut: 'Sign Out',
    language: 'Language',
    profile: 'Profile',
    meetOurTeam: 'Meet our team',
    login: 'Login',
    password: 'Password',
    name: 'Name',
    repeatPassword: 'Repeat password',
    editUser: 'Edit user',
    changePassword: 'Change password',
    deleteUser: 'Delete user',
    oldPassword: 'Old password',
    newPassword: 'New password',
    enterYourPassword: 'Enter your password',
    enterYourLogin: 'Enter your login',
    enterYourName: 'Enter your name',
    emptyField: 'Empty field!',
    onlyNumbersLetters: 'Only numbers and english letters',
    lessThanFour: ' can not be less than 4 symbols',
    passwordsMatch: 'Passwords do not match',
    createBoard: 'Create a new board',
    createColumn: 'New column',
    createTask: 'Add task',
    yourBoards: 'Your boards',
    board: 'Board',
    boards: 'Boards',
    boardsHeader: 'Main page',
    openBoard: 'Open board',
    back: 'Back',
    submit: 'Submit',
    cancel: 'Cancel',
    doYouWantToDelete: 'Do you want to delete ',
    areYouSure: 'Are you sure?',
    error: 'Error!',
    success: 'Success!',
    updateSuccessful: 'update successful!',
    user: 'User',
    wrongPassword: 'Wrong password',
    afterDeleteRedirect: 'After deletion, you will be redirected to the welcome page!',
    update: 'Update',
    loading: 'Loading...',
    addATitle: 'Add a title',
    addADescription: 'Add a description',
    author: 'User',
    yourTask: 'Task',
    taskDescription: 'Description',
    shatau: 'Yauheni Shatau',
    kochieva: 'Victoria Kochieva',
    karakulka: 'Dzmitry Karakulka',
    doYouWantToChangeUser: 'Choose new task user',
    welcome: 'Welcome',
    app: "It's Your Project Management App",
    aboutProject:
      "Project management app is an application that assigns tasks to individual participants in a project or group. It is the visual tool that empowers your team to manage any type of project, workflow, or task tracking. Add files, checklists, or even automation: Customize it all for how your team works best. Just sign up, create a board, and you're off!",
    course:
      'RS School is free-of-charge and community-based education program conducted by The Rolling Scopes developer community since 2013. Everyone can study at RS School, regardless of age, professional employment, or place of residence. The mentors and trainers of our school are front-end and javascript developers from different companies and countries. RS School operates "Pay it forward" principle. We share our knowledge with students for free at the present time, hoping that in the future they will return to us as mentors and pass on their knowledge to the next generation of students in the same way.',
    courseAbout: 'About the course',
  },
};
